import type { Dispatch, SetStateAction } from 'react';

import { DropdownMenu, DropdownMenuContent } from 'design-system';

import HistoryRecord from '@/features/ai-chat/components/AskGXDrawer/ChatHistory/HistoryRecord/HistoryRecord';

import { useChatHistory } from './useChatHistory';

const ChatHistory = ({
  anchorEl,
  setAnchorEl
}: {
  anchorEl: HTMLElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
}) => {
  const { conversations, handleClose } = useChatHistory(setAnchorEl);

  return (
    <DropdownMenu
      open={Boolean(anchorEl)}
      onOpenChange={nextOpen => {
        if (!nextOpen) handleClose();
      }}
    >
      <DropdownMenuContent
        align='end'
        anchor={anchorEl}
        className='w-80 p-0'
        positionerClassName='z-[var(--z-panel-floating)]'
      >
        <div className='ml-2 text-[10px] text-gx-text-disabled'>CHAT HISTORY</div>
        {conversations.length === 0 ? (
          <div className='flex h-[75px] items-center justify-center'>No history yet</div>
        ) : (
          conversations.map((conversation, index) => (
            <HistoryRecord
              key={conversation.conversationId}
              conversation={conversation}
              handleClose={handleClose}
              index={index}
            />
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ChatHistory;
